/**
 * Carries a partial write to a renter's typed preferences.
 *
 * An omitted field is left alone. Null erases the stored value.
 */
export class UpdateProtoUserSettingsDto {
  languageId?: number | null;
  timezone?: string | null;
}
